import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import Anchor from 'ember-wiser/components/anchor';
import Button from 'ember-wiser/components/button';
import Details from 'ember-wiser/components/details';
import NavBar from 'parog-web/components/nav-bar';
import type NavigationService from 'parog-web/services/navigation';
import type SemeiaSessionService from 'parog-web/services/session';
import type TermsOfUseService from 'parog-web/services/terms-of-use';
import PageContainer from 'ui-kit/components/page-container';
export default class LegalInfoTermsOfUseComponent extends Component {
  @service declare navigation: NavigationService;
  @service declare session: SemeiaSessionService;
  @service declare termsOfUse: TermsOfUseService;

  get shouldAcceptLatestTermsOfUseVersion() {
    return (
      Boolean(this.session?.user) && !this.session?.user?.isAcceptedTermsOfUse
    );
  }

  get shouldDisplayArticle51(): boolean {
    const allowedFur = [
      'cardio-transplant',
      'hepato-transplant',
      'pneumo-transplant'
    ];

    return this.session.patient?.followUpReason
      ? allowedFur.includes(this.session.patient.followUpReason)
      : false;
  }

  back = () => {
    this.navigation.back();
  };

  <template>
    <NavBar @shouldHideProfileIcon={{this.shouldAcceptLatestTermsOfUseVersion}}>
      Informations légales
    </NavBar>

    <PageContainer @background='transparent'>
      <:content>
        <div class='my-2'>
          <Details
            @open={{false}}
            @summary="Informations légales sur l'entreprise Sêmeia"
          >
            <h4>
              L’application internet semeia.app est édité par&nbsp;:
            </h4>
            <p>
              La société Sêmeia, société par actions simplifiée au capital de 6
              076,00 euros, enregistrée au RCS de PARIS sous le numéro 829 055
              854, dont le Numéro de TVA intracommunautaire est FR
              80&nbsp;829&nbsp;055 854, dont le siège est 174 Quai de Jemmapes
              75010 - Paris France, représentée par son président, Monsieur
              Daniel Szeftel.
            </p>
            <p>
              La société Sêmeia SAS peut être jointe à l’adresse mail
              contact@semeia.io
            </p>
            <h4>
              L’application internet semeia.app est hébergée par&nbsp;:
            </h4>
            <p>
              Le directeur de la publication est M. Daniel Szeftel.
            </p>
            <p>
              L’application internet Sêmeia.app est hébergée à Roubaix par la
              société OVHcloud, 2 rue Kellermann, 59100 Roubaix, France.
            </p>
            <p>
              Les données de santé à caractère personnel sont hébergées en
              France chez un hébergeur agréé&nbsp;: OVH, société par actions
              simplifiées au capital de 10 0679 020 €, enregistrée au RCS de
              Lille Métropole sous le numéro 424 781 419, dont le numéro de TVA
              intercommunautaire est le FR 22 424 781 419, dont le siège social
              est sis 2 rue Kellermann 59100 – Paris.
            </p>
          </Details>
        </div>

        <div class='my-2'>
          <Anchor
            href='https://semeia.notion.site/semeia/Conditions-G-n-rales-d-Utilisation-de-la-solution-S-meia-a4be3e19453b46579688426793e1e95c'
            target='_blank'
            rel='noopener noreferrer'
            class='text-grey'
          >
            Conditions Générales d'Utilisation de la solution Sêmeia
          </Anchor>
        </div>

        <div class='my-2'>
          <Anchor
            href='https://semeia.notion.site/semeia/Politique-de-confidentialit-e89b953187b84d398d3f06d59a57b060'
            target='_blank'
            rel='noopener noreferrer'
            class='text-grey'
          >
            Politique de confidentialité
          </Anchor>
        </div>

        <div class='my-2'>
          <Anchor
            href='https://semeia.notion.site/semeia/Politique-Cookies-85e5c5f459334e75b0b4f41253ed3d59'
            target='_blank'
            rel='noopener noreferrer'
            class='text-grey'
          >
            Politique de Cookies
          </Anchor>
        </div>

        <div class='my-2'>
          <Anchor
            href='https://www.notion.so/semeia/Etiquettes-produits-6ff35089efbf40a1a6f3b19924f5c18b'
            target='_blank'
            rel='noopener noreferrer'
            class='text-grey'
          >
            Étiquettes produits
          </Anchor>
        </div>

        <div class='my-2'>
          <Anchor
            href='https://semeia.notion.site/semeia/Manuels-utilisateurs-S-meia-Wise-V6-7-1-21e890468ac64dd2a20916811b44b5f9'
            target='_blank'
            rel='noopener noreferrer'
            class='text-grey'
          >
            Manuel utilisateurs
          </Anchor>
        </div>

        <div class='my-2'>
          <Details @open={{false}} @summary='Autres informations'>
            L'application Pilot v.1, éditée par la société Sêmeia, est
            homologuée en date du 23 septembre 2020 en authentification directe
            pour le profil DMP consultation uniquement.
            <br />
            Les fonctions DMP intégrées sont :
            <ul>
              <li>Vérification de l'existence d'un dossier DPM pour un patient</li>
              <li>Vérification et application de l'autorisation d'un médecin à
                l'accès au DMP d'un patient</li>
              <li>Consultation des documents du DMP d'un patient</li>
              <li>Consultation du contenu d'un document DMP d'un patient</li>
            </ul>
            <b>L'application utilise un outil pour accéder au DMP :</b>
            <ul>
              <li>
                DmpConnect v.3, édité par la société icanopée, est homologué en
                mode EAI en date du 17 avril 2019 en authentification directe et
                indirecte, pour tous les profils d'accès DMP : Accès sécurisé,
                Création et Gestion Administrative, Alimentation et
                Consultation.
              </li>
            </ul>
            <br />
            <b>L'application utilise l'identification électronique par Pro Santé
              Connect.</b>
            <br />
            Pro Santé Connect est un téléservice mis en œuvre par l’Agence du
            Numérique en Santé (ANS) contribuant à simplifier l’identification
            électronique des professionnels intervenant en santé.
            <br />
            L’utilisateur peut se connecter grâce à son application mobile e-CPS
            ou sa carte CPS, avec un lecteur de cartes et les composants
            nécessaires.
          </Details>
        </div>

        {{#if this.shouldDisplayArticle51}}
          <div class='my-2'>
            <Details
              @open={{false}}
              @summary='Information sur l’utilisation de vos données personnelles pour
        l’évaluation d’une expérimentation « Article 51 »'
              data-test='article-51'
            >
              <p>
                Madame, Monsieur,
              </p>
              <p>
                Vous avez été inclus(e) par votre équipe soignante dans un
                programme de télésurveillance médicale, financé actuellement
                dans le cadre d’un programme d’expérimentations proposé par le
                Ministère des solidarités et de la santé et l’Assurance maladie.
              </p>
              <p>
                Ce programme, appelé
                <b>« expérimentation Article 51 « télésurveillance des patients
                  transplantés »»</b>, vise à améliorer la qualité de vos soins
                et de votre suivi en développant des formes innovantes
                d’organisation des soins. Pour les professionnels de santé qui
                vous suivent, il s’agit d’envisager de nouvelles manières de
                travailler, plus collectives, qui ont pour but d’améliorer la
                coordination et la continuité des soins. Vous pouvez trouver des
                informations détaillées sur ce programme sur le site du
                Ministère des solidarités et de la santé dans la rubrique
                <i>« Expérimenter et innover pour mieux soigner »</i>.
              </p>
              <p>
                La loi impose que
                <b>toutes les « expérimentations Article 51 » fassent l’objet
                  d’une évaluation</b>
                visant à apprécier leur bon fonctionnement et leurs résultats.
                Ces évaluations aideront à décider si cette expérimentation doit
                être ou non étendue à l’ensemble du système de santé français.
                Elles consistent en des travaux d’études, d’enquêtes et
                d’analyses statistiques.
              </p>
              <p>
                Ces évaluations seront réalisées par des équipes d’évaluateurs
                spécialisées missionnées par le Ministère des solidarités et de
                la santé et de la Caisse nationale d’assurance maladie, qui
                assurent conjointement la responsabilité du traitement des
                données. L’Agence régionale de santé de votre région est
                également engagée dans le dispositif.
                <b>Ces évaluations sont encadrées par une autorisation de la
                  Commission nationale de l’informatique et des libertés (CNIL)</b>
                délivrée après l’appréciation des conditions de sécurité et de
                confidentialité dans lesquelles vos données seront utilisées
                (numéro de l’autorisation 2022-072).
              </p>
              <p>
                Les analyses menées par les évaluateurs seront réalisées sur la
                base de données vous concernant,
                <b>sans utilisation de données nominatives (données
                  pseudonymisées)</b>. Ces données contribueront à produire des
                statistiques permettant d’observer et d’analyser les effets de
                l’expérimentation. Plusieurs types de données pourront être
                utilisées :
              </p>
              <ul>
                <li>
                  Données transmises à l’Assurance Maladie, par les
                  professionnels participant pour décrire l’activité réalisée
                  dans le cadre de l’expérimentation : il s’agit de données
                  issues de votre dossier médical décrivant votre prise en
                  charge (consultations, interventions chirurgicales, examens,
                  actions de dépistage…) ou votre état de santé (résultats de
                  vos examens par exemple) ;
                  <b>ces données seront toujours traitées</b>
                  sans aucune donnée directement identifiante ;
                </li>
                <li>
                  Données complémentaires de remboursement des soins - qui sont
                  dispensés dans le cadre de l’expérimentation - et qui auront
                  été transmises par vos soignants à l’Assurance maladie, sur
                  une plateforme sécurisée de facturation dédiée ;
                </li>
                <li>
                  Données concernant tous les autres remboursements de vos
                  soins, issues du Système National des Données de Santé (SNDS)
                  géré par l’Assurance Maladie.
                </li>
              </ul>
              <p>
                Ces données pourront être croisées entre elles. Pour la
                réalisation de ces croisements, certaines données identifiantes
                seront transmises à un tiers de confiance qui fera le lien entre
                les différentes sources de données sans avoir accès aux données
                elles-mêmes.
              </p>
              <p>
                De plus, dans certains cas, nous souhaiterions également pouvoir
                recueillir votre avis sur votre accompagnement dans le cadre de
                l’expérimentation. Vous pourrez alors être contacté.e pour
                répondre à une enquête ou participer à des entretiens avec les
                évaluateurs.
                <b>Votre participation est totalement volontaire, vos réponses
                  ne permettront pas de vous identifier et les professionnels de
                  santé qui vous suivent n’en auront pas connaissance</b>.
              </p>
              <p>
                Les données recueillies à des fins d’évaluations seront
                conservées sous une forme ne permettant pas de vous identifier
                directement pour une durée de 3 ans après la fin de
                l’expérimentation.
              </p>
              <p>
                Conformément au Règlement Général sur la Protection des Données
                (RGPD), vous pouvez à tout moment vous opposer au traitement de
                vos données dans le cadre de l’évaluation des « expérimentations
                Article 51 » ou à la transmission de vos données de contact aux
                évaluateurs. De même, vous pouvez exercer votre droit d’accès à
                ces données ou de rectification.
                <b>Ces demandes ne modifieront en rien votre prise en charge ni
                  le remboursement des soins par l’Assurance maladie</b>.
              </p>
              <p>
                Ces droits, s’exercent auprès du Délégué à la Protection Des
                données (DPO) du responsable de traitement. Vous pouvez leur
                adresser vos demandes :
              </p>
              <ul>
                <li>
                  Par e-mail, à l’adresse électronique suivante :
                  donneespersonnelles@semeia.io
                </li>
                <li>
                  Par courrier postal à l’adresse suivante : 174, quai de
                  Jemmapes, 75010 Paris France
                </li>
              </ul>
              <p>
                Vous pouvez introduire une réclamation auprès de la Commission
                nationale de l’informatique et des libertés (CNIL), 3, place de
                Fontenoy TSA 80715 75334 Paris Cedex 07.
              </p>
            </Details>
          </div>
        {{/if}}
        <div class='my-4 flex justify-end'>
          <Button
            @icon='Close'
            @variant='outlined'
            @ariaLabel='Retour'
            {{on 'click' this.back}}
          >Fermer</Button>
        </div>

      </:content>
    </PageContainer>
  </template>
}
